import { createAction, props } from "@ngrx/store";

export const subrogationSummaryStart = createAction(
  "[subrogation-summary] subrogation_summary_start",
  props<{ claimNumber: string }>()
);
